import { useEffect, useState } from "react";

let currentValue = false;
const listeners = new Set<(value: boolean) => void>();

export const toggleDevTools = (): void => {
  currentValue = !currentValue;
  listeners.forEach((fn) => fn(currentValue));
};

export const useDevToolsVisible = (): boolean => {
  const [visible, setVisible] = useState<boolean>(currentValue);

  useEffect(() => {
    listeners.add(setVisible);
    return (): void => {
      listeners.delete(setVisible);
    };
  }, []);

  return visible;
};
